import { AnyAction } from 'redux';
import { handleActions } from 'redux-actions';

// reducers
const defaultState = {
  labOrderList: {},
  labMessageList: {},
};

type State = typeof defaultState;

const reducer = handleActions<State, AnyAction>({
  // [`${getLaboratoryOrdersAction}`](state: State, { params, payload }: AnyAction) {
  //   const newPayload = payload;
  //   newPayload.tab = params?.status;
  //   return {
  //     ...state,
  //     labOrderList: newPayload,
  //   };
  // },
}, defaultState);

export default reducer;
